import React from "react";
import {Form, Input, Modal, Select, Switch} from "antd";
import {FormModalProps} from "../../utils/useFormModal";

function ModifyModal(props: FormModalProps) {
    const {form, ...otherProps} = props
    return (
        <Modal {...otherProps}>
            <Form form={form} layout={'vertical'}>
                <Form.Item name={'description'} label={'名称'} rules={[{required: true}]}>
                    <Input/>
                </Form.Item>
                <Form.Item name={'cronExpression'} label={'Cron'} rules={[{required: true}]}>
                    <Input/>
                </Form.Item>
                <Form.Item name={'jobClassName'} label={'类'} rules={[{required: true}]}>
                    <Input/>
                </Form.Item>
                <Form.Item name={'status'} label={'状态'}>
                    <Select>
                        <Select.Option value={0}>启用</Select.Option>
                        <Select.Option value={-1}>停用</Select.Option>
                    </Select>
                </Form.Item>
            </Form>
        </Modal>
    )
}

export default ModifyModal
